import EADialog from "components/common/EADialog";
import useStyles from "./EsgScoreModalStyle";
import ClassificationEsgScore from "./ClassificationEsgScore";
import i18next from "i18next";
import { convert } from "html-to-text";
import TopicExamplesTooltip from "./TopicExamplesTooltip";

const SocialScoreModal = ({dataESG, esgDetailsContent, isOpen, onClose}) => {
    const {classes} = useStyles();
    if(!esgDetailsContent) {
        return <></>
    }

    const formatThemeScore = (value) => {
        return value?.substring(value?.indexOf(":")+1, value?.length)
    }

    return (
        <EADialog isOpen={isOpen && esgDetailsContent} onClose={onClose} title={i18next.t("ESG.subjectSocialData")} maxWidth="lg" hasActions={false}>
            <div className={classes.gridColumns}>
                
                {dataESG?.socialRankingScore && 
                    <div>
                        <div className={classes.subTitle}>{esgDetailsContent["classification_title"]}</div>
                        <ClassificationEsgScore esgDetailsContent={esgDetailsContent} score={String(dataESG?.socialRankingScore)} />
                    </div>
                }

                <div>
                    <div className={classes.subTitle}>{esgDetailsContent["depth_scores_title"]}</div>
                    <div className={classes.flex}>
                        <div className={classes.score_bold}>{esgDetailsContent["social_depth"]}</div>
                        <div className={classes.depthDescription}>{convert(esgDetailsContent["s_data_depth_description"])}</div>
                    </div>

                </div>
            </div>

            <table className={classes.table_scores}>
            <thead>
            <tr className={classes.table_scores_header}>
                    <th>{i18next.t("ESG.theme")}</th>
                    <th>{esgDetailsContent["table_header_score"]}</th>
                    <th className={classes.topicWidth}>{i18next.t("ESG.topic")}</th>
                    <th>{esgDetailsContent["table_header_score"]}</th>
                    <th>{esgDetailsContent["table_header_description"]}</th>
            </tr>
            </thead>
            <tbody>
                <tr className={classes.topBorder}> 
                    <td className={classes.content_bold}>
                        <div className={classes.table_scores_theme_label}>{esgDetailsContent["social_certifications_theme_label"]}</div>
                    </td>
                    <td className={classes.rightBorder}>
                        <div className={classes.table_scores_theme_score}>{formatThemeScore(esgDetailsContent["social_certifications_theme_score"])}</div>
                    </td>
                    <td className={classes.content_bold}>{esgDetailsContent["social_related_certifications_label"]}</td>
                    <td className={classes.topic_score}>{esgDetailsContent["social_related_certifications_score"]}</td>
                    <td>{esgDetailsContent["social_related_certifications_description"]}<TopicExamplesTooltip title={esgDetailsContent["table_header_examples"]} content ={esgDetailsContent["social_related_certifications_examples"]}/></td>
                </tr>
                <tr className={classes.topBorder}>  
                    <td className={classes.content_bold}>
                        <div className={classes.table_scores_theme_label}>{esgDetailsContent["community_engagement_theme_label"]}</div>
                    </td>
                    <td className={classes.rightBorder}>
                        <div className={classes.table_scores_theme_score}>{formatThemeScore(esgDetailsContent["community_engagement_theme_score"])}</div>
                    </td>
                    <td className={classes.content_bold}>{esgDetailsContent["community_engagement_label"]}</td>
                    <td className={classes.topic_score}>{esgDetailsContent["community_engagement_score"]}</td>
                    <td>{esgDetailsContent["community_engagement_description"]}<TopicExamplesTooltip title={esgDetailsContent["table_header_examples"]} content ={esgDetailsContent["community_engagement_examples"]}/></td>
                
                </tr>
                <tr>
                    <td></td>
                    <td className={classes.rightBorder}></td>
                    <td className={classes.content_bold}>{esgDetailsContent["corporate_philanthropy_label"]}</td>
                    <td className={classes.topic_score}>{esgDetailsContent["corporate_philanthropy_score"]}</td>
                    <td>{esgDetailsContent["corporate_philanthropy_description"]}<TopicExamplesTooltip title={esgDetailsContent["table_header_examples"]} content ={esgDetailsContent["corporate_philanthropy_examples"]}/></td>
                </tr>

                <tr className={classes.topBorder}> 
                    <td className={classes.content_bold}>
                        <div className={classes.table_scores_theme_label}>{esgDetailsContent["customer_engagement_theme_label"]}</div>
                    </td>
                    <td className={classes.rightBorder}>
                        <div className={classes.table_scores_theme_score}>{formatThemeScore(esgDetailsContent["customer_engagement_theme_score"])}</div>
                    </td>
                    <td className={classes.content_bold}>{esgDetailsContent["data_privacy_label"]}</td>
                    <td className={classes.topic_score}>{esgDetailsContent["data_privacy_score"]}</td>
                    <td>{esgDetailsContent["data_privacy_description"]}<TopicExamplesTooltip title={esgDetailsContent["table_header_examples"]} content ={esgDetailsContent["data_privacy_examples"]}/></td>
                </tr>

                <tr>
                    <td></td>
                    <td className={classes.rightBorder}></td>
                    <td className={classes.content_bold}>{esgDetailsContent["products_services_label"]}</td>
                    <td className={classes.topic_score}>{esgDetailsContent["products_services_score"]}</td>
                    <td>{esgDetailsContent["products_services_description"]}<TopicExamplesTooltip title={esgDetailsContent["table_header_examples"]} content ={esgDetailsContent["products_services_examples"]}/></td>
                </tr>

                <tr className={classes.topBorder}> 
                    <td className={classes.content_bold}>
                        <div className={classes.table_scores_theme_label}>{esgDetailsContent["human_capital_theme_label"]}</div>
                    </td>
                    <td className={classes.rightBorder}>
                        <div className={classes.table_scores_theme_score}>{formatThemeScore(esgDetailsContent["human_capital_theme_score"])}</div>
                    </td>
                    <td className={classes.content_bold}>{esgDetailsContent["diversity_inclusion_label"]}</td>
                    <td className={classes.topic_score}>{esgDetailsContent["diversity_inclusion_score"]}</td>
                    <td>{esgDetailsContent["diversity_inclusion_description"]}<TopicExamplesTooltip title={esgDetailsContent["table_header_examples"]} content ={esgDetailsContent["diversity_inclusion_examples"]}/></td>
                </tr>
                <tr>
                    <td></td>
                    <td className={classes.rightBorder}></td>
                    <td className={classes.content_bold}>{esgDetailsContent["health_safety_label"]}</td>
                    <td className={classes.topic_score}>{esgDetailsContent["health_safety_score"]}</td>
                    <td>{esgDetailsContent["health_safety_description"]}<TopicExamplesTooltip title={esgDetailsContent["table_header_examples"]} content ={esgDetailsContent["health_safety_examples"]}/></td>
                </tr>
                <tr>
                    <td></td>
                    <td className={classes.rightBorder}></td>
                    <td className={classes.content_bold}>{esgDetailsContent["human_rights_abuses_label"]}</td>
                    <td className={classes.topic_score}>{esgDetailsContent["human_rights_abuses_score"]}</td>
                    <td>{esgDetailsContent["human_rights_abuses_description"]}<TopicExamplesTooltip title={esgDetailsContent["table_header_examples"]} content ={esgDetailsContent["human_rights_abuses_examples"]}/></td>
                </tr>
                <tr>
                    <td></td>
                    <td className={classes.rightBorder}></td>
                    <td className={classes.content_bold}>{esgDetailsContent["labor_relations_label"]}</td>
                    <td className={classes.topic_score}>{esgDetailsContent["labor_relations_score"]}</td>
                    <td>{esgDetailsContent["labor_relations_description"]}<TopicExamplesTooltip title={esgDetailsContent["table_header_examples"]} content ={esgDetailsContent["labor_relations_examples"]}/></td>
                </tr>
                <tr>
                    <td></td>
                    <td className={classes.rightBorder}></td>
                    <td className={classes.content_bold}>{esgDetailsContent["training_education_label"]}</td>
                    <td className={classes.topic_score}>{esgDetailsContent["training_education_score"]}</td>
                    <td>{esgDetailsContent["training_education_description"]}<TopicExamplesTooltip title={esgDetailsContent["table_header_examples"]} content ={esgDetailsContent["training_education_examples"]}/></td>
                </tr>

                <tr className={classes.topBorder}> 
                    <td className={classes.content_bold}>
                        <div className={classes.table_scores_theme_label}>{esgDetailsContent["product_service_theme_label"]}</div>
                    </td>
                    <td className={classes.rightBorder}>
                        <div className={classes.table_scores_theme_score}>{formatThemeScore(esgDetailsContent["product_service_theme_score"])}</div>
                    </td>
                    <td className={classes.content_bold}>{esgDetailsContent["cyber_risk_label"]}</td>
                    <td className={classes.topic_score}>{esgDetailsContent["cyber_risk_score"]}</td>
                    <td>{esgDetailsContent["cyber_risk_description"]}<TopicExamplesTooltip title={esgDetailsContent["table_header_examples"]} content ={esgDetailsContent["cyber_risk_examples"]}/></td>
                </tr>

                <tr>
                    <td></td>
                    <td className={classes.rightBorder}></td>
                    <td className={classes.content_bold}>{esgDetailsContent["product_quality_label"]}</td>
                    <td className={classes.topic_score}>{esgDetailsContent["product_quality_score"]}</td>
                    <td>{esgDetailsContent["product_quality_description"]}<TopicExamplesTooltip title={esgDetailsContent["table_header_examples"]} content ={esgDetailsContent["product_quality_examples"]}/></td>
                </tr>

                <tr className={classes.topBorder}>
                    <td className={classes.content_bold}>
                        <div className={classes.table_scores_theme_label}>{esgDetailsContent["supplier_engagement_theme_label"]}</div>
                    </td>
                    <td className={classes.rightBorder}>
                        <div className={classes.table_scores_theme_score}>{formatThemeScore(esgDetailsContent["supplier_engagement_theme_score"])}</div>
                    </td>
                    <td className={classes.content_bold}>{esgDetailsContent["supplier_engagement_label"]}</td>
                    <td className={classes.topic_score}>{esgDetailsContent["supplier_engagement_score"]}</td>
                    <td>{esgDetailsContent["supplier_engagement_description"]}<TopicExamplesTooltip title={esgDetailsContent["table_header_examples"]} content ={esgDetailsContent["supplier_engagement_examples"]}/></td>
               
                </tr>

            </tbody>
            </table>

        </EADialog>
    )
}

export default SocialScoreModal;